// src/features/boe/components/programs/Program1400.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_1400_CONFIG = {
  fullName: "SCHOOL COUNSELING",
  docId: "1400",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsCounselors",
      label: "Positions – Counselors",
      valueType: "count",
      sources: [{ block: "Positions", key: "Counselors" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsPsychologists",
      label: "Positions – Psychologists",
      valueType: "count",
      sources: [{ block: "Positions", key: "Psychologists" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsAcademicEvaluators",
      label: "Positions – Academic Evaluators",
      valueType: "count",
      sources: [{ block: "Positions", key: "Academic Evaluators" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsParaeducators",
      label: "Positions – Paraeducators",
      valueType: "count",
      sources: [
        { block: "Positions", key: "Paraeducators" },
      ],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSecretarial",
      label: "Positions – Secretarial",
      valueType: "count",
      sources: [{ block: "Positions", key: "Secretarial" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Administrative" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesCounselors",
      label: "Salaries – Counselors",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Counselors" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesPsychologists",
      label: "Salaries – Psychologists",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Psychologists" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesAcademicEvaluators",
      label: "Salaries – Academic Evaluators",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Academic Evaluators" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarial",
      label: "Salaries – Secretarial",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secretarial" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSummerHelpCertified",
      label: "Salaries – Summer Help, Certified",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Summer Help, Certified" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesParaeducators",
      label: "Salaries – Paraeducators",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Paraeducators" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesParaPTSmith",
      label: "Salaries – Para, P-T Smith School",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Para, P-T Smith School" }],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "scholasticAptitudeTest",
      label: "Scholastic Aptitude Test",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Scholastic Aptitude Test" },
      ],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "collegePlanningPrograms",
      label: "College Planning Programs",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "College Planning Programs" },
      ],
      group: "services",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "suppliesMaterials",
      label: "Supplies / Materials",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Supplies / Materials" },
        { block: "Supplies / Materials", key: "Supplies" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "reunion50Year",
      label: "50 Year Reunion",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "50 Year Reunion" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "technologySoftware",
      label: "Technology Software",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Technology Software" },
        { block: "Supplies / Materials", key: "Technology - Software" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "duesFees",
      label: "Dues & Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues and Fees" },
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues & Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approvedMain",
      title: "1400 SCHOOL COUNSELING – Approved",
      sectionKey: "Approved",
      fields: [
        "positionsAdmin",
        "positionsCounselors",
        "positionsPsychologists",
        "positionsParaeducators",
        "positionsSecretarial",
        "salariesAdmin",
        "salariesCounselors",
        "salariesPsychologists",
        "salariesSecretarial",
        "salariesSummerHelpCertified",
        "salariesParaeducators",
        "salariesParaPTSmith",
        "scholasticAptitudeTest",
        "collegePlanningPrograms",
        "suppliesMaterials",
        "reunion50Year",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "130px" },
        positionsCounselors: { minWidth: "140px" },
        positionsPsychologists: { minWidth: "140px" },
        positionsParaeducators: { minWidth: "160px" },
        positionsSecretarial: { minWidth: "130px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesCounselors: { minWidth: "150px" },
        salariesPsychologists: { minWidth: "150px" },
        salariesSecretarial: { minWidth: "140px" },
        salariesSummerHelpCertified: { minWidth: "170px" },
        salariesParaeducators: { minWidth: "160px" },
        salariesParaPTSmith: { minWidth: "170px" },

        // Services
        scholasticAptitudeTest: { minWidth: "170px" },
        collegePlanningPrograms: { minWidth: "190px" },

        // Materials / Other
        suppliesMaterials: { minWidth: "150px" },
        reunion50Year: { minWidth: "130px" },
        technologySoftware: { minWidth: "160px" },
        duesFees: { minWidth: "110px" },
      },
    },
    {
      id: "actualMain",
      title: "1400 SCHOOL COUNSELING – Actual",
      sectionKey: "Actual",
      fields: [
        "positionsAdmin",
        "positionsCounselors",
        "positionsPsychologists",
        "positionsParaeducators",
        "positionsSecretarial",
        "salariesAdmin",
        "salariesCounselors",
        "salariesPsychologists",
        "salariesSecretarial",
        "salariesSummerHelpCertified",
        "salariesParaeducators",
        "salariesParaPTSmith",
        "scholasticAptitudeTest",
        "collegePlanningPrograms",
        "suppliesMaterials",
        "reunion50Year",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "130px" },
        positionsCounselors: { minWidth: "140px" },
        positionsPsychologists: { minWidth: "140px" },
        positionsParaeducators: { minWidth: "160px" },
        positionsSecretarial: { minWidth: "130px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesCounselors: { minWidth: "150px" },
        salariesPsychologists: { minWidth: "150px" },
        salariesSecretarial: { minWidth: "140px" },
        salariesSummerHelpCertified: { minWidth: "170px" },
        salariesParaeducators: { minWidth: "160px" },
        salariesParaPTSmith: { minWidth: "170px" },

        // Services
        scholasticAptitudeTest: { minWidth: "170px" },
        collegePlanningPrograms: { minWidth: "190px" },

        // Materials / Other
        suppliesMaterials: { minWidth: "150px" },
        reunion50Year: { minWidth: "130px" },
        technologySoftware: { minWidth: "160px" },
        duesFees: { minWidth: "110px" },
      },
    },
  ],

  inflationSumFields: null,
};

export function Program1400(props) {
  return (
    <ProgramBudget programId="1400" config={PROGRAM_1400_CONFIG} {...props} />
  );
}
